import { render } from "./FinishSignup.vue?vue&type=template&id=3dd4d31e&scoped=true"
import script from "./FinishSignup.vue?vue&type=script&lang=js"
export * from "./FinishSignup.vue?vue&type=script&lang=js"

import "./FinishSignup.vue?vue&type=style&index=0&id=3dd4d31e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo.ETAGEN\\Documents\\Adam-Backend\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd4d31e"]])

export default __exports__